import ForgotPasswordForm from '../../components/forgot-password-form/forgot-password-form.component';
import './forgot-password.styles.scss';

const ForgotPassword = () => {
    return (
        <div className='forgot-password-container'>
            <ForgotPasswordForm/>
        </div>
    )
}

export default ForgotPassword;